import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProgressService } from '../../service/progress.service';
import { BaseModalComponent } from '../../common/modal/base-modal/base-modal.component';
import { Observable } from 'rxjs';
import { Role } from '../../model/auth/Role';
import { Teacher } from '../../model/auth/User';
import { ContestService } from '../../service/contest.service';
import { NotificationHandler } from '../../helper/notification.handler';

export interface TeacherSelectData {
  competitionId: string;
  contestId: string;
  regionId: string;
  schoolId: string;
  userIds: string[];

  teacher?: Teacher;
}

@Component({
  selector: 'app-select-teacher-modal',
  templateUrl: './select-teacher-modal.component.html',
  styleUrls: ['./select-teacher-modal.component.scss'],
})
export class SelectTeacherModalComponent extends BaseModalComponent {

  readonly roles = [Role.Host, Role.Coordinator, Role.Teacher, Role.Student];

  @ViewChild('dialogContent', {static: true}) protected progressContainer!: ElementRef;

  readonly competitionId: string;
  readonly contestId: string;
  readonly regionId: string;
  readonly schoolId: string;
  readonly userIds: string[];

  teacher?: Teacher;

  constructor(private contestService: ContestService,
              dialogRef: MatDialogRef<SelectTeacherModalComponent>,
              progressService: ProgressService,
              @Inject(MAT_DIALOG_DATA) data: TeacherSelectData) {
    super(dialogRef, progressService);

    this.competitionId = data.competitionId;
    this.contestId = data.contestId;
    this.regionId = data.regionId;
    this.schoolId = data.schoolId;
    this.userIds = data.userIds;

    this.teacher = data.teacher;
  }

  loadTeachers = (): Observable<Teacher[]> => {
    return this.contestService.geTeachers(this.competitionId, this.contestId, this.regionId, this.schoolId);
  };

  compareTeachers(t1?: Teacher, t2?: Teacher): boolean {
    return t1 != undefined && t2 != undefined && t1.teacher_id === t2.teacher_id;
  }

  displayTeacher(teacher: Teacher): string {
    return `${teacher.teacher_first_name} ${teacher.teacher_last_name}`;
  }

  handleTeacherSelected(teacher: Teacher) {
    this.teacher = teacher;
  }

  proceedAllowed(): boolean {
    return !!this.teacher;
  }

  proceed(): void {
    if (!this.teacher) return;

    this.startProgress();

    this.contestService.assignTeacher(this.competitionId, this.contestId, this.teacher.teacher_id, this.userIds).subscribe({
      next: users => {
        this.closeModal(users);
        this.stopProgress();
      },
      error: error => {
        NotificationHandler.handleError($localize`:Notifications|Teacher assign has failed message@@notifications-teacher-assign-failed-error:Teacher assign has failed`, error);
        this.stopProgress();
      }
    });
  }

}
